import { EDIT_INVENTORY_ITEM, NEW_INVENTORY_ITEM } from "@rpforms/shared";
import { openEditor } from "@rpforms/shared/build/actions/editor";
import { approveInventoryItem } from "@rpforms/shared/build/actions/inventory_items";
import { SmallButton, SmallDangerButton } from "@rpforms/shared/build/components/layout/Button";
import { skillLabels } from "@rpforms/shared/build/constants";
import React from "react";
import { Badge } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { COMPANY_ID } from "../../config";
import { ActionCell, ActionLine } from "./RowActions";

const ServicePositionTableRow = ({
    servicePosition,
    deleteServicePosition = null,
    onUpdated,
}: any) => {
    const dispatch = useDispatch();

    const confirmAction = (cb) => {
        if (confirm("Sind Sie sich sicher dieses Objekt zu löschen?")) {
            cb();
        }
    };

    const editServicePosition = () => {
        dispatch(
            openEditor({
                endpoint: `inventory_items`,
                endpointCompany: false,
                new: !servicePosition.id,
                preload: {
                    company_id: COMPANY_ID,
                    inventory_type: "service",
                    ...servicePosition,
                },
                type: !servicePosition.id ? NEW_INVENTORY_ITEM : EDIT_INVENTORY_ITEM,
                submitCallback: () => {
                    if (onUpdated) {
                        onUpdated();
                    }
                },
            })
        );
    };

    const approve = async () => {
        await dispatch(approveInventoryItem(servicePosition));
        if (onUpdated) {
            onUpdated();
        }
    };

    const duplicateServicePosition = () => {
        dispatch(
            openEditor({
                endpoint: `inventory_items`,
                endpointCompany: false,
                new: true,
                preload: {
                    company_id: COMPANY_ID,
                    inventory_type: "service",
                    name: servicePosition.name,
                    short_name: servicePosition.short_name,
                    description: servicePosition.description,
                    sales_price: servicePosition.sales_price || 0,
                    allowed_form_types: servicePosition.allowed_form_types || [],
                    skills: servicePosition.skills || [],
                },
                type: NEW_INVENTORY_ITEM,
                submitCallback: () => {
                    if (onUpdated) {
                        onUpdated();
                    }
                },
            })
        );
    };

    if (!servicePosition) {
        return <></>;
    }

    return (
        <tr>
            <td>
                <strong>{servicePosition.short_name}</strong>
            </td>
            <td>
                <strong>{servicePosition.name}</strong>
            </td>
            <td>{servicePosition.description}</td>
            <td>{skillLabels(servicePosition.skills) || <>–</>}</td>
            <td className={"text-right"}>
                <strong>{servicePosition.sales_price_formatted}</strong>
            </td>
            <td>{servicePosition.form_names}</td>

            <td>
                <ActionCell>
                    {(servicePosition.source === "ai_import" ||
                        servicePosition.approved === false) && (
                        <ActionLine>
                            {servicePosition.source === "ai_import" && (
                                <Badge variant="info">KI-Import</Badge>
                            )}
                            {servicePosition.approved === false && (
                                <Badge variant="warning">Nicht freigegeben</Badge>
                            )}
                        </ActionLine>
                    )}
                    <ActionLine>
                        {servicePosition.approved === false && (
                            <SmallButton onClick={approve}>Freigeben</SmallButton>
                        )}
                        <SmallButton onClick={editServicePosition}>Bearbeiten</SmallButton>
                        <SmallButton onClick={duplicateServicePosition}>Duplizieren</SmallButton>
                        {deleteServicePosition !== null && (
                            <SmallDangerButton
                                onClick={() =>
                                    confirmAction(() => deleteServicePosition(servicePosition))
                                }
                            >
                                <i className={"fa fa-trash"}></i>
                            </SmallDangerButton>
                        )}
                    </ActionLine>
                </ActionCell>
            </td>
        </tr>
    );
};

export default withRouter(ServicePositionTableRow);
